// Run this BEFORE the theme initializes AjaxProduct
//const form = document.querySelector('.product-single__form');
const atcProductOffer = document.querySelector('.add-product-offer');
const cartDrawerButton = document.querySelector('.js-drawer-open-cart');
const purchaseTypes = document.querySelectorAll('input[name="purchaseType"]');
const mainAtc = document.querySelector('.product-single__form button[data-add-to-cart]');
const offerRadio = document.querySelector('#purchaseProductOffer');
const sellingPlanSelect = document.querySelector('.selling-plan-selector');
const hiddenSellingPlanInput = document.querySelector('input[name="selling_plan"]');
const priceWrapper = document.querySelector('.purchase-option__price');
const comparePriceEl = document.querySelector('.purchase-option__compare');
const currentPriceEl = document.querySelector('.purchase-option__current');
const subscriptionPricePerDrinkEl = document.querySelector('.purchase-option--subscription [data-price-per-drink]');
const switchToSavePriceEl = document.querySelector('[data-switch-to-save-price]');
const purchaseOptions = document.querySelector('.purchase-options');
const purchaseOptionsContainer = document.querySelector('.purchase-options-container');
const purchaseOptionsLbls = document.querySelectorAll('.purchase-option');
const launchBadge = document.querySelector('.bundle-product-offer .launch-badge');
let sellingPlanSelect2Attempts = 0;
let sellingPlanSelect2PositionFrame = null;

function isMocktailsB2bPack() {
    return (
        (document.documentElement.classList.contains('b2b-customer') || window.ANANDA_B2B_CUSTOMER === true) &&
        !!document.querySelector('[data-product-handle="mocktails"]')
    );
}

function snapB2bQty(val) {
    var min = 4;
    var step = 4;
    var n = parseInt(val, 10);
    if (isNaN(n)) return min;
    if (n < min) return min;
    return min + Math.round((n - min) / step) * step;
}

function getSummerMocktailQuantity(trigger) {
    const productSection = document.querySelector('[data-section-type="product"]') || document;
    const productForm = trigger
        ? trigger.closest('.product-single__form')
        : document.querySelector('.product-single__form');
    const quantityWithAtc = productForm ? productForm.closest('.quantity-with-atc') : null;
    const formQuantity = productForm ? productForm.querySelector('input[name="quantity"]') : null;
    let formDataQuantity = null;

    if (productForm) {
        try {
            formDataQuantity = new FormData(productForm).get('quantity');
        } catch (error) {
            formDataQuantity = null;
        }
    }

    const localQuantity = quantityWithAtc
        ? quantityWithAtc.querySelector('.product__quantity input[name="quantity"]')
        : null;
    const linkedQuantity = productForm && productForm.id
        ? productSection.querySelector(`input[name="quantity"][form="${productForm.id}"]`)
        : null;
    const quantityInput = formQuantity || localQuantity || linkedQuantity || productSection.querySelector('.product__quantity input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (quantity && quantity > 0) {
        return isMocktailsB2bPack() ? snapB2bQty(quantity) : quantity;
    }

    const parsedFormDataQuantity = parseInt(formDataQuantity, 10);
    if (parsedFormDataQuantity && parsedFormDataQuantity > 0) {
        return isMocktailsB2bPack() ? snapB2bQty(parsedFormDataQuantity) : parsedFormDataQuantity;
    }

    return isMocktailsB2bPack() ? 4 : 1;
}

document.addEventListener('DOMContentLoaded', function() {
    initSummerDescriptionToggle();
    initSubscriptionFreeGiftsCarousel();
    initSellingPlanSelect2();
    initPurchaseOptionsVariantState();

    if (isMocktailsB2bPack()) {
        var onetimeRadio = document.querySelector('input[name="purchaseType"][value="onetime"]');
        if (onetimeRadio) {
            onetimeRadio.checked = true;
            onetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (mainAtc) mainAtc.style.display = 'inline-block';
        if (atcProductOffer) atcProductOffer.style.display = 'none';
        if (launchBadge) launchBadge.classList.remove('selected');
        if (hiddenSellingPlanInput) hiddenSellingPlanInput.value = '';
    } else if (offerRadio) {
        offerRadio.click();
    }

    if (!purchaseTypes.length) {
        return;
    }

    purchaseTypes.forEach(el => {
        el.addEventListener('change', function() {
            if (isMocktailsB2bPack() && el.value !== 'onetime') {
                var resetOnetime = document.querySelector('input[name="purchaseType"][value="onetime"]');
                if (resetOnetime) {
                    resetOnetime.checked = true;
                    resetOnetime.dispatchEvent(new Event('change', { bubbles: true }));
                }
                return;
            }

            purchaseOptionsLbls.forEach(el => {
                el.classList.remove('opt-selected');
            });
            const purchaseOptionLbl = el.closest('.purchase-option');
            purchaseOptionLbl.classList.add('opt-selected');
            
            if(el.value === 'purchaseProductOffer') {
                if (mainAtc) mainAtc.style.display = 'none';
                if (atcProductOffer) atcProductOffer.style.display = 'inline-block';
                if (launchBadge) launchBadge.classList.add('selected');
            }
            else {
                if (mainAtc) mainAtc.style.display = 'inline-block';
                if (atcProductOffer) atcProductOffer.style.display = 'none';
                if (launchBadge) launchBadge.classList.remove('selected');
            }
            updateSellingPlan();
            refreshSubscriptionFreeGiftsCarousel();
        });
    })

    if (atcProductOffer) {
        atcProductOffer.addEventListener('click', async (e) => {
            e.preventDefault();

            if (isMocktailsB2bPack()) {
                var productForm = document.querySelector('.product-single__form');
                if (productForm && typeof productForm.requestSubmit === 'function') {
                    productForm.requestSubmit();
                }
                return;
            }

            if (offerRadio?.checked) {
                const variantId = offerRadio.dataset.variantId;

                try {
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            items: [
                                {
                                    id: variantId,
                                    quantity: getSummerMocktailQuantity(e.currentTarget)
                                }
                            ]
                        })
                    });

                    const data = await response.json();

                    console.log('Added:', data);
                    if (typeof window.ANANDA_SYNC_BOTTLE_DISCOUNT_CART_ATTRIBUTES === 'function') {
                        await window.ANANDA_SYNC_BOTTLE_DISCOUNT_CART_ATTRIBUTES().catch(function(err) {
                            console.warn('[BottleDiscount] Could not sync cart attributes:', err);
                        });
                    }
                    const localCartDrawer = new theme.CartDrawer();
                    if (cartDrawerButton) {
                        cartDrawerButton.click();
                    }

                    document.dispatchEvent(
                        new CustomEvent('cart:refresh')
                    );
                } catch (error) {
                    console.error('Add to cart failed:', error);
                }
            }
        });
    }

    
    // Initial load
    updateSellingPlan();

    // Change subscription frequency
    if (sellingPlanSelect) {
        sellingPlanSelect.addEventListener('change', updateSellingPlan);
    }

    if (typeof Fancybox !== 'undefined') {
        Fancybox.bind("[data-fancybox]", {});
    }
});

function initPurchaseOptionsVariantState() {
    if (!purchaseOptions) return;

    syncPurchaseOptionsVariantState();

    document.addEventListener('change', function(event) {
        if (event.target.closest('.product-variant_picker')) {
            syncPurchaseOptionsVariantState();
        }
    });

    document.addEventListener('input', function(event) {
        if (event.target.closest('.product-variant_picker')) {
            syncPurchaseOptionsVariantState();
        }
    });

    document.addEventListener('click', function(event) {
        if (!event.target.closest('.product-variant_picker')) return;

        window.setTimeout(syncPurchaseOptionsVariantState, 0);
    });
}

function syncPurchaseOptionsVariantState() {
    if (!purchaseOptions) return;

    const isAwaitingVariant = !hasSelectedVariantFromPicker();
    purchaseOptionsContainer.classList.toggle('is-awaiting-variant', isAwaitingVariant);
    //purchaseOptions.classList.toggle('is-awaiting-variant', isAwaitingVariant);

    if (isAwaitingVariant) {
        clearDeliveryPurchaseOptions();
    }
}

function clearDeliveryPurchaseOptions() {
    purchaseOptions
        .querySelectorAll('.purchase-option--onetime, .purchase-option--subscription')
        .forEach(option => {
            option.classList.remove('opt-selected');

            const input = option.querySelector('input[name="purchaseType"]');
            if (input) input.checked = false;
        });

    updateSellingPlan();
}

function hasSelectedVariantFromPicker() {
    const picker = document.querySelector('.product-variant_picker');
    if (!picker) return true;

    const creamSodaFlavorPicker = picker.querySelector('.variant-wrapper--cream-soda-flavor');
    if (creamSodaFlavorPicker) {
        if (creamSodaFlavorPicker.querySelector('[data-cream-soda-bundle-offer][aria-pressed="true"]')) return true;
        if (creamSodaFlavorPicker.querySelector('.variant-input.has-quantity')) return true;

        const quantityInputs = creamSodaFlavorPicker.querySelectorAll('[data-cream-soda-flavor-qty]');
        return Array.from(quantityInputs).some(input => parseInt(input.value, 10) > 0);
    }

    if (picker.querySelector('input[type="radio"][data-variant-input]:checked, input[type="radio"]:checked')) {
        return true;
    }

    return Array.from(picker.querySelectorAll('select')).some(select => select.value);
}

function positionSellingPlanSelect2Below() {
    if (!sellingPlanSelect || !window.jQuery) return;

    const $select = window.jQuery(sellingPlanSelect);
    const select2 = $select.data('select2');
    if (!select2 || !select2.isOpen() || !select2.dropdown || !select2.dropdown.$dropdown) return;

    const $selectionContainer = select2.$container;
    const $dropdown = select2.dropdown.$dropdown;
    const $dropdownContainer = select2.dropdown.$dropdownContainer || $dropdown.parent();
    let $offsetParent = $select.closest('.purchase-option__plans');

    if ($offsetParent.css('position') === 'static') {
        $offsetParent = $offsetParent.offsetParent();
    }

    const selectionOffset = $selectionContainer.offset();
    const parentOffset = $offsetParent.offset() || { top: 0, left: 0 };
    if (!selectionOffset || !$dropdownContainer.length) return;

    $selectionContainer.removeClass('select2-container--above').addClass('select2-container--below');
    $dropdown.removeClass('select2-dropdown--above').addClass('select2-dropdown--below');
    $dropdownContainer
        .removeClass('select2-container--above')
        .addClass('select2-container--below')
        .css({
            top: selectionOffset.top + $selectionContainer.outerHeight(false) - parentOffset.top,
            left: selectionOffset.left - parentOffset.left
        });
}

function scheduleSellingPlanSelect2Below() {
    if (sellingPlanSelect2PositionFrame !== null) {
        window.cancelAnimationFrame(sellingPlanSelect2PositionFrame);
    }

    sellingPlanSelect2PositionFrame = window.requestAnimationFrame(() => {
        sellingPlanSelect2PositionFrame = null;
        positionSellingPlanSelect2Below();
    });
}

function bindSellingPlanSelect2Positioning() {
    unbindSellingPlanSelect2Positioning();
    document.addEventListener('scroll', scheduleSellingPlanSelect2Below, true);
    window.addEventListener('resize', scheduleSellingPlanSelect2Below);
    window.addEventListener('orientationchange', scheduleSellingPlanSelect2Below);
    scheduleSellingPlanSelect2Below();
}

function unbindSellingPlanSelect2Positioning() {
    document.removeEventListener('scroll', scheduleSellingPlanSelect2Below, true);
    window.removeEventListener('resize', scheduleSellingPlanSelect2Below);
    window.removeEventListener('orientationchange', scheduleSellingPlanSelect2Below);

    if (sellingPlanSelect2PositionFrame !== null) {
        window.cancelAnimationFrame(sellingPlanSelect2PositionFrame);
        sellingPlanSelect2PositionFrame = null;
    }
}

function initSellingPlanSelect2() {
    if (!sellingPlanSelect) return;

    if (!window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.select2 !== 'function') {
        sellingPlanSelect2Attempts += 1;
        if (sellingPlanSelect2Attempts <= 20) {
            window.setTimeout(initSellingPlanSelect2, 100);
        }
        return;
    }

    const $select = window.jQuery(sellingPlanSelect);
    if ($select.hasClass('select2-hidden-accessible')) return;

    $select.select2({
        minimumResultsForSearch: Infinity,
        dropdownParent: $select.closest('.purchase-option__plans'),
        width: '100%'
    });

    $select.on('select2:open.sellingPlanPosition', bindSellingPlanSelect2Positioning);
    $select.on('select2:close.sellingPlanPosition', unbindSellingPlanSelect2Positioning);
    $select.on('select2:select.sellingPlanPosition', function() {
        sellingPlanSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
}

function initSubscriptionFreeGiftsCarousel() {
    if (typeof window.Flickity === 'undefined') return;

    document.querySelectorAll('[data-subscription-free-gifts-carousel]').forEach(carousel => {
        if (carousel.freeGiftsFlickityInstance) return;

        carousel.freeGiftsFlickityInstance = new window.Flickity(carousel, {
            cellAlign: 'left',
            contain: true,
            freeScroll: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            watchCSS: false
        });
    });

    refreshSubscriptionFreeGiftsCarousel();
}

function refreshSubscriptionFreeGiftsCarousel() {
    document.querySelectorAll('[data-subscription-free-gifts-carousel]').forEach(carousel => {
        if (carousel.freeGiftsFlickityInstance && typeof carousel.freeGiftsFlickityInstance.resize === 'function') {
            window.setTimeout(() => carousel.freeGiftsFlickityInstance.resize(), 0);
        }
    });
}

function initSummerDescriptionToggle() {
    const descriptionBlock = document.querySelector('[data-summer-description-toggle]');
    if (!descriptionBlock) return;

    const description = descriptionBlock.querySelector('.rte');
    if (!description) return;

    const originalHtml = description.innerHTML;
    const fullText = description.textContent.replace(/\s+/g, ' ').trim();
    const mobileQuery = window.matchMedia('(max-width: 768px)');
    const collapsedLength = 76;

    if (fullText.length <= collapsedLength) return;

    function renderCollapsed() {
        const trimmedText = fullText.slice(0, collapsedLength).replace(/\s+\S*$/, '');

        description.innerHTML = '';
        description.append(document.createTextNode(`${trimmedText}... `));
        description.append(createToggleButton('Read more', false));
        descriptionBlock.classList.add('summer-description-toggle', 'is-collapsed');
        descriptionBlock.classList.remove('is-expanded');
    }

    function renderExpanded() {
        description.innerHTML = originalHtml;
        description.append(createToggleButton('Read less', true));
        descriptionBlock.classList.add('summer-description-toggle', 'is-expanded');
        descriptionBlock.classList.remove('is-collapsed');
    }

    function createToggleButton(label, isExpanded) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'summer-description-toggle__button';
        button.textContent = label;
        button.setAttribute('aria-expanded', String(isExpanded));
        button.addEventListener('click', isExpanded ? renderCollapsed : renderExpanded);
        return button;
    }

    function syncDescription() {
        if (mobileQuery.matches) {
            renderCollapsed();
        } else {
            description.innerHTML = originalHtml;
            descriptionBlock.classList.remove('summer-description-toggle', 'is-collapsed', 'is-expanded');
        }
    }

    syncDescription();

    if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', syncDescription);
    } else {
        mobileQuery.addListener(syncDescription);
    }
}

function updatePricePerDrink(el, priceCents) {
    if (!el || !priceCents || !window.Shopify || typeof window.Shopify.formatMoney !== 'function') return;

    const servings = parseFloat(el.dataset.pricePerDrinkServings) || 30;
    if (servings <= 0) return;

    el.textContent = Shopify.formatMoney(Math.round(parseFloat(priceCents) / servings));
}

function updateSwitchToSavePrice(comparePriceCents, priceCents) {
    if (!switchToSavePriceEl || !comparePriceCents || !priceCents || !window.Shopify || typeof window.Shopify.formatMoney !== 'function') return;

    const savings = parseFloat(comparePriceCents) - parseFloat(priceCents);
    switchToSavePriceEl.textContent = Shopify.formatMoney(Math.max(0, Math.round(savings)));
}


function updateSellingPlan() {
    const selectedPurchaseType = document.querySelector('input[name="purchaseType"]:checked');
    const isSubscription = selectedPurchaseType && selectedPurchaseType.value === 'subscription';

    if (!hiddenSellingPlanInput) return;

    // Subscription selected
    if (isSubscription && sellingPlanSelect) {
        hiddenSellingPlanInput.value = sellingPlanSelect.value;
    } 
    else {
        // One-time purchase
        hiddenSellingPlanInput.value = '';
    }

    // Price display
    if (sellingPlanSelect) {
        const selectedOption = sellingPlanSelect.options[sellingPlanSelect.selectedIndex];

        const price = selectedOption.dataset.price;
        const priceCents = selectedOption.dataset.priceCents;
        const comparePrice = selectedOption.dataset.comparePrice;
        const comparePriceCents = selectedOption.dataset.comparePriceCents;

        if (currentPriceEl && price) currentPriceEl.textContent = price;
        updatePricePerDrink(subscriptionPricePerDrinkEl, priceCents);
        updateSwitchToSavePrice(comparePriceCents, priceCents);

        if (comparePriceEl && comparePrice) {
            comparePriceEl.textContent = comparePrice;
        }
    } 
    else if (priceWrapper && currentPriceEl) {
        const defaultPrice = priceWrapper.dataset.productPrice;
        const defaultComparePrice = priceWrapper.dataset.productComparePrice;

        if (defaultPrice && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            currentPriceEl.textContent = Shopify.formatMoney(defaultPrice);
        }

        if (comparePriceEl && defaultComparePrice && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            comparePriceEl.textContent = Shopify.formatMoney(defaultComparePrice);
        }
    }
}
